export default "__VITE_ASSET__B_sZ35wF__"